module.exports = __webpack_public_path__ + "img/pc_icon_phone-bg.52ecad42.png";